__webpack_require__.p = "/reports-skeleton-ui-improvement/account-setup/";